import {
  Alert,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';
import {
  createRNFiz3Request,
  updateRNFiz3Request,
} from '../../../redux/rnfizRedux';

const RN_Fiz_3 = ({ props }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const [releaseDecision, setReleaseDecision] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.releaseDecision : false,
  );
  const [releaseQty, setReleaseQty] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.releaseQty : '',
  );
  const [repairDecision, setRepairDecision] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.repairDecision : false,
  );
  const [repairQty, setRepairQty] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.repairQty : '',
  );
  const [destructionDecision, setDestructionDecision] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.destructionDecision : false,
  );
  const [destructionQty, setDestructionQty] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.destructionQty : '',
  );

  const [decisionDate, setDecisionDate] = useState(
    props.RN_Fiz_3 ? dayjs(props.RN_Fiz_3.decisionDate) : dayjs(new Date()),
  );
  const [comment, setComment] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3.comment : '',
  );
  const [decisionMaker, setDecisionMaker] = useState(
    props.RN_Fiz_3
      ? `${props.RN_Fiz_3.user.firstName} ${props.RN_Fiz_3.user.lastName}`
      : user.users.firstName + ' ' + user.users.lastName,
  );
  const [reloadReport, setReloadReport] = useState(0);
  const [dataDecision, setDataDecision] = useState(
    props.RN_Fiz_3 ? props.RN_Fiz_3 : false,
  );
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    const start = async () => {
      console.log('Ładowanie danych rozlewu ...');
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setDataDecision(res.data.RN_Fiz_3 ? res.data.RN_Fiz_3 : false);
        console.log('Dane rozlewu załadowane:', res.data.RN_Fiz_3);
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const RN_Fiz_3_data = {
      reportPZ04Id: props.id,
      releaseDecision,
      releaseQty: releaseDecision ? releaseQty : '',
      repairDecision,
      repairQty: repairDecision ? repairQty : '',
      destructionDecision,
      destructionQty: destructionDecision ? destructionQty : '',
      comment,
      decisionDate,
      userId: user.users.id,
    };

    if (dataDecision) {
      RN_Fiz_3_data.id = dataDecision.id;
      const res = await dispatch(updateRNFiz3Request(RN_Fiz_3_data));
      if (res.status === 200) {
        setAlertOpen(true);
        setAlertSeverity('success');
        setAlertMessage(t('rnModule.fiz_3.snackbar.successUpdateData'));
        setReloadReport((prev) => prev + 1);
        console.log('Zaktualizowano decyzję mikrobiologiczną 4', res);
      } else {
        setAlertOpen(true);
        setAlertSeverity('error');
        setAlertMessage(t('rnModule.fiz_3.snackbar.errorUpdateData'));
        console.log('Błąd aktualizacji decyzji mikrobiologicznej 4', res);
      }
    } else {
      const res = await dispatch(createRNFiz3Request(RN_Fiz_3_data));
      if (res.status === 201) {
        setAlertOpen(true);
        setAlertSeverity('success');
        setAlertMessage(t('rnModule.fiz_3.snackbar.successAddData'));
        setReloadReport((prev) => prev + 1);
        console.log('Dodano decyzję mikrobiologiczną 4', res);
      } else {
        setAlertOpen(true);
        setAlertSeverity('error');
        setAlertMessage(t('rnModule.fiz_3.snackbar.errorAddData'));
        console.log('Błąd dodania decyzji mikrobiologicznej 4', res);
      }
    }
  };
  return (
    <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert
          variant="filled"
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Tooltip
        placement="top"
        slots={{ transition: Zoom }}
        title={
          <Typography>{t('rnModule.fiz_3.tooltipDescription')}</Typography>
        }
        style={{ fontSize: '20px' }}
      >
        <Typography
          variant="h6"
          component="h2"
          width="300px"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.fiz_3.description')}
        </Typography>
      </Tooltip>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        component={'form'}
        onSubmit={handleSubmit}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Typography variant="h6" component="h2" fontWeight="bold">
            {t('rnModule.fiz_3.proceeding')}
          </Typography>
        </Box>
        <Typography variant="h6" component="h2" fontWeight="bold">
          {t('rnModule.fiz_3.decision')}
        </Typography>
        <FormGroup sx={{ width: '100%', mb: 2 }}>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.fiz_3.decisionRelease')}
              sx={{ width: '450px' }}
              checked={releaseDecision}
              onChange={(e) => setReleaseDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.fiz_3.qtyCAS')}
              value={releaseQty}
              onChange={(e) => setReleaseQty(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              disabled={!releaseDecision}
            />
          </Box>

          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.fiz_3.decisionDestroy')}
              sx={{ width: '450px' }}
              checked={destructionDecision}
              onChange={(e) => setDestructionDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.fiz_3.qtyCAS')}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              value={destructionQty}
              onChange={(e) => setDestructionQty(e.target.value)}
              disabled={!destructionDecision}
            />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.fiz_3.decisionRepair')}
              sx={{ width: '450px' }}
              checked={repairDecision}
              onChange={(e) => setRepairDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.fiz_3.qtyCAS')}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              disabled={!repairDecision}
              value={repairQty}
              onChange={(e) => setRepairQty(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <TextField
              label={t('rnModule.fiz_3.comment')}
              variant="outlined"
              size="small"
              sx={{ width: '660px', mb: 3 }}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mb: 2,
              justifyContent: 'left',
            }}
          >
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD.MM.YYYY"
                views={['year', 'month', 'day']}
                label={t('rnModule.fiz_3.dateOfDecision')}
                value={dayjs(decisionDate)}
                onChange={(newValue) => {
                  setDecisionDate(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Tooltip
              placement="top"
              slots={{ transition: Zoom }}
              title={
                <Typography>
                  {t('rnModule.fiz_3.tooltipDescription')}
                </Typography>
              }
              style={{ fontSize: '20px' }}
            >
              <TextField
                sx={{ width: '25%', ml: 2, mr: 2 }}
                label={t('rnModule.fiz_3.decisionMakerSignature')}
                variant="outlined"
                value={decisionMaker}
                disabled
              />
            </Tooltip>
          </Box>
        </FormGroup>

        <Button
          type="submit"
          sx={{
            color: 'white',
            bgcolor: '#C09A53',
            ':hover': { bgcolor: '#9c7c43' },
            height: '40px',
            width: '250px',
            mt: 2,
            mb: 50,
          }}
        >
          {t('rnModule.fiz_3.button.confirmData')}
        </Button>
      </Box>
    </Box>
  );
};

export default RN_Fiz_3;
